import { useQuery } from '@tanstack/react-query';
import { useCurrentOrganizationData } from './useCurrentOrganization.js';
import { organizationService } from '@syscolect/domain';
import { useDispatchHookEvent } from '@rammetec/core';
/**
 * Hook to fetch all users in the current organization with their roles.
 * Uses organizationService.getOrganizationUsers which returns userData and orgUserData separately.
 *
 * Hook that fetches organization users (user + role data) for the active organization.
 */
export const useOrganizationUsers = (enabled = true) => {
    const { organizationData } = useCurrentOrganizationData();
    const { data: users, isLoading, error } = useQuery({
        queryKey: ['orgUsers', organizationData?.id],
        queryFn: () => {
            if (!organizationData?.id) {
                return [];
            }
            return organizationService.getOrganizationUsers(organizationData.id);
        },
        enabled: !!organizationData?.id && enabled,
    });
    useDispatchHookEvent('useOrganizationUsers', {
        users,
        isLoading,
        error,
        organizationId: organizationData?.id,
    });
    return {
        users: users || [],
        isLoading,
        error,
    };
};
//# sourceMappingURL=useOrganizationUsers.js.map